




































// 3rd party
import {
    mapGetters,
    mapActions,
} from 'vuex';

// Components
import backButton from '@webapp/components/back-button/back-button.vue';
import prizeDetailsItem from '@webapp/modules/rewards/components/leaderboards/prize-details-item.vue';

export default {
    name: 'prize-details',
    components: {
        backButton,
        prizeDetailsItem,
    },
    computed: {
        ...mapGetters('leaderboards', [
            'getSpecificLeaderboard',
            'sortPrizes',
        ]),

        ...mapGetters(['getTranslatedStr']),

        sortedPrizesList() {
            return this.sortPrizes(this.getSpecificLeaderboard.leaderboardPrize);
        },

        termsUrl() {
            return this.getTranslatedStr(this.getSpecificLeaderboard, 'termsUrl', this.getSpecificLeaderboard.termsUrl);
        },
    },
    async created() {
        await this.fetchSpecificLeaderboard({
            leaderboardId: this.$route.params.id,
        });
    },
    methods: {
        ...mapActions('leaderboards', ['fetchSpecificLeaderboard']),

        mainPrizeImage(prize) {
            if (prize.prizeType?.images) {
                const image = prize.prizeType.images.find((imgObj) => imgObj.imageType.type === 'main') || {};

                return image?.url || '';
            }

            return '';
        },
    },
};
